import { Controller } from "@hotwired/stimulus"

// Story 2.E.2 (21/05/2026) — Ferme la modale KPI sans recharger la page Performance.
// Avant : close_href: performance_dashboard_path → GET sur /dashboard/performance
// (lourd : recalcule tous les KPIs). Maintenant : vide juste le turbo-frame.
//
// Bind : data-controller="kpi-modal-close"
//        data-action="kpi-modal-close#close" sur le bouton X
//        data-action="click->kpi-modal-close#closeOnBackdrop" sur l'overlay
export default class extends Controller {
  connect() {
    this._escHandler = this._handleEsc.bind(this)
    document.addEventListener("keydown", this._escHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this._escHandler)
  }

  close(event) {
    if (event) event.preventDefault()
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.innerHTML = ""
    } else {
      this.element.remove()
    }
  }

  closeOnBackdrop(event) {
    // Ne ferme QUE si on clique le backdrop lui-même (pas un enfant).
    if (event.target === event.currentTarget) {
      this.close(event)
    }
  }

  _handleEsc(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }

  // Story 2.E.6 — Toggle l'inline form de commentaire sur une row Deal inactif.
  // Bind : data-action="kpi-modal-close#toggleCommentForm" sur le bouton.
  // Cible le sibling .kpi-modal-comment-form le plus proche (next sibling row).
  toggleCommentForm(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const targetId = btn.dataset.commentTarget
    if (!targetId) return
    const form = document.getElementById(targetId)
    if (!form) return
    form.classList.toggle("hidden")
    if (!form.classList.contains("hidden")) {
      const textarea = form.querySelector("textarea")
      if (textarea) textarea.focus()
    }
  }
}
